/**
 * Simulador de prazo na PDP: CEP (ViaCEP + Cart shipping_rates) + dias de fabricação.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'andrade_cep';
  var BR_PROVINCES = {
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins',
  };

  var cartLock = Promise.resolve();
  var RATE_CACHE_MS = 30 * 60 * 1000;

  function cacheKey(cep, variantId) {
    return 'andrade_ship_' + cep + '_' + variantId;
  }

  function readRateCache(cep, variantId) {
    try {
      var raw = sessionStorage.getItem(cacheKey(cep, variantId));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || Date.now() - parsed.ts > RATE_CACHE_MS) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeRateCache(cep, variantId, place, rates) {
    if (!rates || !rates.length) return;
    try {
      sessionStorage.setItem(
        cacheKey(cep, variantId),
        JSON.stringify({ ts: Date.now(), place: place, rates: rates })
      );
    } catch (e) {}
  }

  function digits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatCep(value) {
    var d = digits(value);
    if (d.length > 5) return d.slice(0, 5) + '-' + d.slice(5);
    return d;
  }

  function fillTemplate(tpl, vars) {
    var out = String(tpl || '');
    Object.keys(vars).forEach(function (key) {
      var token = '__' + key.toUpperCase() + '__';
      out = out.split(token).join(vars[key] == null ? '' : String(vars[key]));
    });
    return out;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDate(date) {
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function addBusinessDays(start, days) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    var guard = 0;
    while (added < days && guard < 400) {
      d.setDate(d.getDate() + 1);
      var weekday = d.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
      guard += 1;
    }
    return d;
  }

  function formatMoney(amount) {
    var n = Number(amount);
    if (!isFinite(n)) return '';
    return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function jsonFetch(url, options) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, options || {})).then(
      function (res) {
        return res.json().then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        }).catch(function () {
          return { ok: res.ok, status: res.status, body: null };
        });
      }
    );
  }

  function getProductionDays() {
    var stock = document.querySelector('[data-md-stock]');
    if (!stock) return 15;
    if (stock.hasAttribute('data-production-full')) return 2;
    var n = Number(stock.getAttribute('data-production-days') || '');
    if (n > 0) return n;
    var match = String(stock.getAttribute('data-production-text') || '').match(/(\d+)/);
    return match ? Number(match[1]) : 15;
  }

  function extractShippingDays(rate) {
    if (!rate) return null;
    if (typeof rate.delivery_days === 'number' && rate.delivery_days > 0) {
      return { min: rate.delivery_days, max: rate.delivery_days };
    }
    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length) {
      var nums = rate.delivery_days.map(Number).filter(function (n) {
        return isFinite(n) && n >= 0;
      });
      if (nums.length) return { min: Math.min.apply(null, nums), max: Math.max.apply(null, nums) };
    }
    var blob = [rate.name, rate.presentment_name, rate.description, rate.code].join(' ');
    var range = blob.match(/(\d+)\s*(?:a|-|–|até)\s*(\d+)\s*dias/i);
    if (range) return { min: Number(range[1]), max: Number(range[2]) };
    var one = blob.match(/(\d+)\s*dias?/i);
    if (one) return { min: Number(one[1]), max: Number(one[1]) };
    return null;
  }

  function shippingParams(zip, city, country, province) {
    var q =
      'shipping_address[zip]=' +
      encodeURIComponent(zip) +
      '&shipping_address[country]=' +
      encodeURIComponent(country || 'Brazil') +
      '&shipping_address[province]=' +
      encodeURIComponent(province || '');
    if (city) q += '&shipping_address[city]=' + encodeURIComponent(city);
    return q;
  }

  function fetchRates(zip, city, uf) {
    var provinceName = BR_PROVINCES[uf] || uf || '';
    var hyphen = zip.length === 8 ? zip.slice(0, 5) + '-' + zip.slice(5) : zip;
    var queries = [
      shippingParams(zip, city, 'Brazil', provinceName),
      shippingParams(hyphen, city, 'Brazil', provinceName),
      shippingParams(zip, city, 'Brazil', uf || ''),
      shippingParams(zip, city, 'BR', uf || ''),
    ];
    var seen = {};
    queries = queries.filter(function (q) {
      if (seen[q]) return false;
      seen[q] = true;
      return true;
    });

    function tryQuery(i) {
      if (i >= queries.length) return Promise.resolve([]);
      var query = queries[i];
      return jsonFetch('/cart/shipping_rates.json?' + query).then(function (res) {
        var rates = (res.body && res.body.shipping_rates) || [];
        if (rates.length) return rates;
        return pollAsyncRates(query, 0).then(function (asyncRates) {
          if (asyncRates.length) return asyncRates;
          return tryQuery(i + 1);
        });
      });
    }

    return tryQuery(0);
  }

  function pollAsyncRates(query, attempt) {
    if (attempt > 8) return Promise.resolve([]);
    return new Promise(function (resolve) {
      setTimeout(resolve, 400);
    }).then(function () {
      return jsonFetch('/cart/async_shipping_rates.json?' + query).then(function (res) {
        var rates = (res.body && res.body.shipping_rates) || [];
        if (rates.length || attempt >= 8) return rates;
        return pollAsyncRates(query, attempt + 1);
      });
    });
  }

  function removeTempLine(key) {
    if (!key) return Promise.resolve(null);
    return jsonFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
  }

  function withProductCart(variantId, fn) {
    cartLock = cartLock.catch(function () {}).then(function () {
      var tempKey = '';
      return jsonFetch('/cart.js')
        .then(function (res) {
          var items = (res.body && res.body.items) || [];
          if (items.length) return { ok: true };
          return jsonFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          }).then(function (added) {
            if (added && added.ok && added.body) {
              tempKey = added.body.key || '';
              if (!tempKey && added.body.items && added.body.items[0]) tempKey = added.body.items[0].key || '';
            }
            return added;
          });
        })
        .then(function (ready) {
          if (ready && ready.ok === false) return [];
          return fn();
        })
        .then(function (result) {
          return removeTempLine(tempKey).then(function () {
            return result || [];
          });
        })
        .catch(function () {
          return removeTempLine(tempKey).then(function () {
            return [];
          });
        });
    });
    return cartLock;
  }

  function lookupCep(cep) {
    return fetch('https://viacep.com.br/ws/' + cep + '/json/', { headers: { Accept: 'application/json' } }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).then(function (data) {
      if (!data || data.erro) return null;
      return { city: data.localidade || '', uf: data.uf || '' };
    }).catch(function () {
      return null;
    });
  }

  if (customElements.get('andrade-shipping-simulator')) return;

  customElements.define(
    'andrade-shipping-simulator',
    class extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.form = this.querySelector('[data-andrade-ship-form]');
        this.input = this.querySelector('[data-andrade-ship-cep]');
        this.status = this.querySelector('[data-andrade-ship-status]');
        this.results = this.querySelector('[data-andrade-ship-results]');
        this.i18n = {};
        try {
          var node = this.querySelector('[data-andrade-ship-i18n]');
          this.i18n = JSON.parse(node.textContent || '{}');
        } catch (e) {
          this.i18n = {};
        }

        var saved = '';
        try {
          saved = localStorage.getItem(STORAGE_KEY) || '';
        } catch (e) {}
        if (this.input && saved) this.input.value = formatCep(saved);

        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.input.addEventListener('input', this.onCepInput.bind(this));

        var section = this.closest('.shopify-section');
        var onVariant = this.syncVariant.bind(this);
        if (section) section.addEventListener('variant:update', onVariant);
        document.addEventListener('variant:update', onVariant);

        if (digits(this.input.value).length === 8) this.calculate();
      }

      syncVariant(event) {
        var resource = event && event.detail && (event.detail.resource || event.detail.data);
        var variant = resource && (resource.variant || resource);
        if (variant && variant.id) this.dataset.variantId = String(variant.id);
        var hidden = this.closest('.shopify-section') && this.closest('.shopify-section').querySelector('[data-md-product-form] [name="id"]');
        if (hidden && hidden.value) this.dataset.variantId = hidden.value;
      }

      onCepInput() {
        var formatted = formatCep(this.input.value);
        this.input.value = formatted;
        var cep = digits(formatted);
        if (cep.length === 8) {
          clearTimeout(this._debounce);
          this._debounce = setTimeout(this.calculate.bind(this), 180);
        }
      }

      onSubmit(event) {
        event.preventDefault();
        this.calculate();
      }

      setStatus(message, isError) {
        if (!this.status) return;
        if (!message) {
          this.status.hidden = true;
          this.status.textContent = '';
          return;
        }
        this.status.hidden = false;
        this.status.textContent = message;
        this.status.classList.toggle('andrade-ship-sim__status--error', Boolean(isError));
      }

      currentVariantId() {
        var form = document.querySelector('[data-md-product-form]');
        var hidden = form && form.querySelector('[name="id"]');
        return (hidden && hidden.value) || this.dataset.variantId;
      }

      calculate() {
        var cep = digits(this.input && this.input.value);
        if (cep.length !== 8) {
          this.results.hidden = true;
          this.setStatus(this.i18n.invalid, true);
          return;
        }

        try {
          localStorage.setItem(STORAGE_KEY, cep);
        } catch (e) {}

        var variantId = this.currentVariantId();
        if (!variantId) {
          this.setStatus(this.i18n.error, true);
          return;
        }

        this._token = (this._token || 0) + 1;
        var token = this._token;

        var cached = readRateCache(cep, variantId);
        if (cached) {
          this.render(cep, cached.place, cached.rates || []);
          return;
        }

        this.setStatus(this.i18n.loading, false);
        this.results.hidden = true;

        var self = this;
        var placePromise = lookupCep(cep);
        withProductCart(variantId, function () {
          return placePromise.then(function (place) {
            return fetchRates(cep, place && place.city, place && place.uf).then(function (rates) {
              return { place: place, rates: rates || [] };
            });
          });
        })
          .then(function (payload) {
            if (token !== self._token) return;
            var place = payload && payload.place;
            var rates = (payload && payload.rates) || [];
            writeRateCache(cep, variantId, place, rates);
            self.render(cep, place, rates);
          })
          .catch(function () {
            if (token !== self._token) return;
            self.setStatus(self.i18n.error, true);
          });
      }

      renderFallback(cep, place, production, ready) {
        var city = (place && place.city) || '';
        var uf = (place && place.uf) || '';
        var cityLine = city
          ? fillTemplate(this.i18n.city, { city: city, uf: uf })
          : formatCep(cep);
        var days = ready ? 2 : production;
        var date = formatDate(addBusinessDays(new Date(), days));
        var arrive = fillTemplate(this.i18n.fallbackArrive, { date: date });
        var note = fillTemplate(this.i18n.fallbackNote, {
          production: String(production),
          city: city || formatCep(cep),
        });
        this.setStatus('');
        this.results.innerHTML =
          '<p class="andrade-ship-sim__city">' +
          escapeHtml(cityLine) +
          '</p><ul class="andrade-ship-sim__list"><li class="andrade-ship-sim__option">' +
          '<p class="andrade-ship-sim__arrive">' +
          escapeHtml(arrive) +
          '</p>' +
          '<p class="andrade-ship-sim__breakdown">' +
          escapeHtml(note) +
          '</p></li></ul>';
        this.results.hidden = false;
      }

      render(cep, place, rates) {
        var city = (place && place.city) || '';
        var uf = (place && place.uf) || '';
        var production = getProductionDays();
        var ready = Boolean(document.querySelector('[data-md-stock][data-production-full]'));

        if (!rates.length) {
          var cityLineEmpty = city
            ? fillTemplate(this.i18n.city, { city: city, uf: uf })
            : formatCep(cep);
          this.setStatus(this.i18n.notFound, true);
          this.results.innerHTML =
            '<p class="andrade-ship-sim__city">' + escapeHtml(cityLineEmpty) + '</p>';
          this.results.hidden = false;
          return;
        }

        this.setStatus('');
        var cityLine = city
          ? fillTemplate(this.i18n.city, { city: city, uf: uf })
          : formatCep(cep);
        var html =
          '<p class="andrade-ship-sim__city">' +
          escapeHtml(cityLine) +
          '</p><ul class="andrade-ship-sim__list">';

        rates.forEach(function (rate) {
          var days = extractShippingDays(rate);
          var priceNum = Number(rate.price);
          var priceLabel = priceNum === 0 ? this.i18n.free : formatMoney(rate.price);
          var name = rate.presentment_name || rate.name || '';
          var arrive = '';
          var breakdown = '';

          if (days) {
            var minTotal = production + days.min;
            var maxTotal = production + days.max;
            var minDate = addBusinessDays(new Date(), minTotal);
            var maxDate = addBusinessDays(new Date(), maxTotal);
            arrive =
              minTotal === maxTotal
                ? fillTemplate(this.i18n.arrives, { date: formatDate(maxDate) })
                : fillTemplate(this.i18n.arrivesRange, {
                    date_min: formatDate(minDate),
                    date_max: formatDate(maxDate),
                  });
            var shipShow = days.min === days.max ? String(days.max) : days.min + ' a ' + days.max;
            var unit = days.max === 1 ? this.i18n.unitOne : this.i18n.unitOther;
            breakdown = ready
              ? fillTemplate(this.i18n.breakdownReady, { shipping: shipShow, unit: unit })
              : fillTemplate(this.i18n.breakdown, {
                  production: String(production),
                  shipping: shipShow,
                  unit: unit,
                });
          } else {
            arrive = fillTemplate(this.i18n.noTransit, {
              production: String(production),
              city: city || formatCep(cep),
            });
          }

          html +=
            '<li class="andrade-ship-sim__option">' +
            '<div class="andrade-ship-sim__option-row">' +
            '<span class="andrade-ship-sim__method">' +
            escapeHtml(name) +
            '</span>' +
            '<span class="andrade-ship-sim__price">' +
            escapeHtml(priceLabel) +
            '</span>' +
            '</div>' +
            (arrive ? '<p class="andrade-ship-sim__arrive">' + escapeHtml(arrive) + '</p>' : '') +
            (breakdown ? '<p class="andrade-ship-sim__breakdown">' + escapeHtml(breakdown) + '</p>' : '') +
            '</li>';
        }, this);

        html += '</ul>';
        this.results.innerHTML = html;
        this.results.hidden = false;
      }
    }
  );
})();
